/*
  Rosebound recommendations engine.
  - Similar books: same genre, spice within one pepper, same age group, shared tropes and moods,
    one book per series (Book 1 only), no other editions of the same book, at most one by the same author.
  - Matching merch: same series first, then the book's main tropes, then genre, mood and spice
    (same rules as the "Pair it with" section). Nothing mature next to YA or kids' books.
  - Cart: fills the free-shipping gap with similar books (gap over $15) or matching merch (smaller gaps),
    priced to close the gap. Falls back to the generic picks Liquid already rendered.
  - Book pages: "You may also like" row.
  Data comes from templates/collection.rb-data.liquid (?view=rb-data).
*/
(function () {
  if (window.RBRecs) return;

  var ALIAS = { 'trope:werewolves-shifters': ['trope:werewolves', 'trope:shifters'], 'trope:monster-romance': ['trope:monster'], 'trope:grumpy-x-sunshine': ['trope:grumpy-sunshine'] };
  var SERIES_NAME = { 'empyrean': 'Fourth Wing', 'acotar': 'ACOTAR', 'throne-of-glass': 'Throne of Glass', 'crescent-city': 'Crescent City', 'shield-of-sparrows': 'Shield of Sparrows', 'dream-harbor': 'Dream Harbor' };
  var SKIP_TYPES = ['Event', 'Gift Card', 'Book Club', ''];
  var BIG_GAP = 1500;
  var MAX_PICKS = 3;

  /* ---------- helpers ---------- */
  function split(v) { return v ? String(v).split('|').filter(Boolean) : []; }
  function pre(list, p) { return list.filter(function (t) { return t.indexOf(p + ':') === 0; }); }
  function handle(t) { return t.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function tropeSlug(v) { return 'trope:' + String(v).toLowerCase().replace(/&/g, ' ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, ''); }
  function label(t) {
    var v = t.split(':')[1] || t;
    if (t.indexOf('series:') === 0 && SERIES_NAME[v]) return SERIES_NAME[v];
    return v.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  function num(tags, p) { var t = pre(tags, p)[0]; return t ? parseFloat(t.split(':')[1]) : NaN; }
  function author(title) { var i = title.lastIndexOf(' by '); return i > -1 ? title.slice(i + 4).trim().toLowerCase() : ''; }
  function baseTitle(title) {
    var i = title.lastIndexOf(' by ');
    var t = i > -1 ? title.slice(0, i) : title;
    return t.replace(/\s*\(.*?\)\s*/g, ' ').replace(/\s*-\s*preorder.*$/i, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function isYoung(tags) { return tags.some(function (g) { return /^genre:(young-adult|childrens)/.test(g); }); }
  function isKids(tags) { return tags.indexOf('genre:childrens') > -1; }
  function isMature(tags) { return tags.indexOf('flag:mature') > -1 || tags.indexOf('theme:spicy') > -1; }
  function previewParam() {
    var m = location.search.match(/preview_theme_id=(\d+)/);
    return m ? '&preview_theme_id=' + m[1] : '';
  }

  /* ---------- data ----------
     Feeds are cached in localStorage for 24h (instant on later pages and visits) and refreshed in
     the background once they are over 10 minutes old. Extra pages load in parallel. */
  var mem = {}, FRESH = 600000, MAX_AGE = 86400000;
  function store(key, items) {
    var v = JSON.stringify({ ts: Date.now(), items: items });
    try { localStorage.setItem(key, v); return; } catch (e) {}
    try { Object.keys(localStorage).forEach(function (k) { if (/^rb(Data|Merch|Books):/.test(k)) localStorage.removeItem(k); }); localStorage.setItem(key, v); } catch (e) {}
  }
  function loadFeed(path, pagesMax) {
    function url(n) { return path + (path.indexOf('?') > -1 ? '&' : '?') + 'view=rb-data&sort_by=best-selling&page=' + n + previewParam(); }
    function get(n) { return fetch(url(n)).then(function (r) { return r.ok ? r.json() : { items: [], pages: 0 }; }); }
    return get(1).then(function (j) {
      var last = Math.min(j.pages || 1, pagesMax), rest = [];
      for (var n = 2; n <= last; n++) rest.push(get(n));
      return Promise.all(rest).then(function (more) {
        var items = j.items || [];
        more.forEach(function (m) { items = items.concat(m.items || []); });
        return items;
      });
    });
  }
  function fetchFeed(path, pagesMax) {
    var key = 'rbData:' + path;
    if (mem[key]) return mem[key];
    var c = null;
    try { c = JSON.parse(localStorage.getItem(key) || 'null'); } catch (e) {}
    if (c && c.items && Date.now() - c.ts < MAX_AGE) {
      if (Date.now() - c.ts > FRESH) loadFeed(path, pagesMax).then(function (list) { store(key, list); }).catch(function () {});
      return (mem[key] = Promise.resolve(c.items));
    }
    mem[key] = loadFeed(path, pagesMax).then(function (list) { store(key, list); return list; }).catch(function () { return []; });
    return mem[key];
  }

  /* An "anchor" is the product we recommend around: { id, title, type, tags[], tropes[] (website tropes) } */
  function mainTropes(anchor) {
    var out = [];
    (anchor.tropes || []).forEach(function (v) {
      var k = tropeSlug(v); out.push(k);
      (ALIAS[k] || []).forEach(function (a) { out.push(a); });
    });
    if (!out.length) out = pre(anchor.tags, 'trope').slice(0, 3);
    return out;
  }

  /* ---------- similar books ---------- */
  function similarBooks(anchor, exclude) {
    var tags = anchor.tags;
    var genres = pre(tags, 'genre');
    if (!genres.length) return Promise.resolve([]);
    var main = mainTropes(anchor);
    var genre = genres[0];
    var paths = main.slice(0, 3).map(function (t) { return '/collections/all/' + handle(genre) + '+' + handle(t); });
    paths.push('/collections/all/' + handle(genre));

    var aSpice = num(tags, 'spice');
    var aSeries = pre(tags, 'series');
    var aAuthor = author(anchor.title);
    var aBase = baseTitle(anchor.title);
    var aYoung = isYoung(tags);
    var aTropes = pre(tags, 'trope');
    var aMoods = pre(tags, 'mood');

    // weights for the anchor's tags
    var wA = {};
    aTropes.forEach(function (t) { wA[t] = 1; });
    main.forEach(function (t) { wA[t] = 2; });
    aMoods.forEach(function (t) { wA[t] = 0.8; });
    var normA = Math.sqrt(Object.keys(wA).reduce(function (s, k) { return s + wA[k] * wA[k]; }, 0)) || 1;

    return Promise.all(paths.map(function (p) { return fetchFeed(p, 1); })).then(function (lists) {
      var seen = {}, out = [];
      lists.forEach(function (list) { list.forEach(function (b) { if (!seen[b.id]) { seen[b.id] = 1; out.push(b); } }); });
      var scored = [];
      out.forEach(function (b, rank) {
        if (b.y !== 'Book' || !b.v) return;
        if (b.id === anchor.id || (exclude && exclude[b.id])) return;
        if (/preorder/i.test(b.t)) return;
        var g = b.g || [];
        if (isYoung(g) !== aYoung) return;
        if (!g.some(function (t) { return genres.indexOf(t) > -1; })) return;
        var bSpice = num(g, 'spice');
        if (!isNaN(aSpice) && !isNaN(bSpice) && Math.abs(aSpice - bSpice) > 1) return;
        var bSeries = pre(g, 'series');
        if (bSeries.some(function (s) { return aSeries.indexOf(s) > -1; })) return;
        if (bSeries.length) { var n = num(g, 'series-num'); if (!(n === 1)) return; }
        if (baseTitle(b.t) === aBase) return;

        var dot = 0, normB2 = 0, why = '', whyW = 0;
        g.forEach(function (t) {
          var w = t.indexOf('trope:') === 0 ? 1 : (t.indexOf('mood:') === 0 ? 0.8 : 0);
          if (!w) return;
          normB2 += w * w;
          if (wA[t]) {
            dot += wA[t] * w;
            if (t.indexOf('trope:') === 0 && wA[t] > whyW) { whyW = wA[t]; why = label(t); }
          }
        });
        if (!dot) return;
        var s = 10 * dot / (normA * (Math.sqrt(normB2) || 1));
        if (!isNaN(aSpice) && aSpice === bSpice) s += 0.5;
        var sameAuthor = aAuthor && author(b.t) === aAuthor;
        if (sameAuthor) s += 1.5;
        scored.push({ item: b, s: s, rank: rank, why: why, sameAuthor: sameAuthor });
      });
      scored.sort(function (a, b) { return b.s - a.s || a.rank - b.rank; });
      // dedupe editions, max one same-author pick
      var res = [], bases = {}, authors = 0;
      scored.forEach(function (x) {
        var k = baseTitle(x.item.t);
        if (bases[k]) return;
        if (x.sameAuthor) { if (authors) return; authors++; }
        bases[k] = 1;
        res.push(x);
      });
      return res;
    });
  }

  /* ---------- matching merch ---------- */
  function matchingMerch(anchor, exclude) {
    var tags = anchor.tags;
    var main = mainTropes(anchor);
    var bSeries = pre(tags, 'series'), bTropes = pre(tags, 'trope'), bGenre = pre(tags, 'genre'), bMood = pre(tags, 'mood');
    var spice = num(tags, 'spice') || 0;
    var young = isYoung(tags), kids = isKids(tags);
    return fetchFeed('/collections/bookish-merchandise', 4).then(function (items) {
      var scored = [];
      items.forEach(function (m, rank) {
        if (m.y === 'Book' || SKIP_TYPES.indexOf(m.y || '') > -1 || !m.v) return;
        if (m.id === anchor.id || (exclude && exclude[m.id])) return;
        var g = m.g || [];
        if (young && isMature(g)) return;
        if (isKids(g) && !kids) return;
        var s = 0, why = '';
        var ser = g.filter(function (t) { return bSeries.indexOf(t) > -1; });
        if (ser.length) { s += 100; why = label(ser[0]); }
        var hit = g.filter(function (t) { return main.indexOf(t) > -1; });
        if (hit.length) { s += 20 * hit.length; why = why || label(hit[0]); }
        if (g.some(function (t) { return bGenre.indexOf(t) > -1; })) s += 10;
        var weak = g.filter(function (t) { return t.indexOf('trope:') === 0 && bTropes.indexOf(t) > -1 && main.indexOf(t) === -1; });
        if (weak.length) { s += 3; why = why || label(weak[0]); }
        if (!young) {
          if (bMood.indexOf('mood:dark') > -1 && g.indexOf('style:dark') > -1) s += 4;
          if (spice >= 3 && g.indexOf('theme:spicy') > -1) s += 4;
        }
        if (bMood.indexOf('mood:funny') > -1 && g.indexOf('theme:funny') > -1) s += 4;
        if (s >= 10) scored.push({ item: m, s: s, rank: rank, why: why });
      });
      scored.sort(function (a, b) { return b.s - a.s || a.rank - b.rank; });
      return scored;
    });
  }

  /* Books that go with a piece of merch (series first, then tropes, then genre). */
  function booksForMerch(anchor, exclude) {
    var tags = anchor.tags;
    var keys = pre(tags, 'series').concat(pre(tags, 'trope'), pre(tags, 'genre'));
    if (!keys.length) return Promise.resolve([]);
    var mature = isMature(tags), kids = isKids(tags);
    return Promise.all(keys.slice(0, 4).map(function (k) { return fetchFeed('/collections/all/' + handle(k), 1); })).then(function (lists) {
      var out = [], seen = {};
      lists.forEach(function (list, li) {
        var key = keys[li];
        var books = list.filter(function (b) {
          if (b.y !== 'Book' || !b.v || /preorder/i.test(b.t)) return false;
          if (exclude && exclude[b.id]) return false;
          var g = b.g || [];
          if (kids) return isKids(g);
          if (isKids(g)) return false;
          if (mature && isYoung(g)) return false;
          return true;
        });
        if (key.indexOf('series:') === 0) books.sort(function (a, b) { return (num(a.g, 'series-num') || 99) - (num(b.g, 'series-num') || 99); });
        books.forEach(function (b, r) {
          var k = baseTitle(b.t);
          if (seen[k]) return;
          seen[k] = 1;
          out.push({ item: b, s: (key.indexOf('series:') === 0 ? 100 : key.indexOf('trope:') === 0 ? 20 : 10) - r * 0.01, why: label(key) });
        });
      });
      out.sort(function (a, b) { return b.s - a.s; });
      return out;
    });
  }

  /* ---------- cart ---------- */
  function cartCard(x) {
    var it = x.item;
    var li = document.createElement('li');
    li.className = 'rb-fsb-sugg__item';
    li.dataset.rbId = it.id;
    var img;
    if (it.i) { img = document.createElement('img'); img.src = it.i.replace('width=300', 'width=160'); img.alt = it.t; img.width = 56; img.height = 56; }
    else { img = document.createElement('span'); }
    img.className = 'rb-fsb-sugg__img';
    li.appendChild(img);
    var mid = document.createElement('div');
    var a = document.createElement('a');
    a.className = 'rb-fsb-sugg__name';
    a.href = it.u;
    a.textContent = it.t;
    mid.appendChild(a);
    var meta = document.createElement('span');
    meta.className = 'rb-fsb-sugg__price';
    meta.textContent = it.p + (x.why ? ' · ' + x.why : '');
    mid.appendChild(meta);
    li.appendChild(mid);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'button button--secondary rb-fsb-sugg__add';
    btn.dataset.rbAdd = it.v;
    btn.setAttribute('aria-label', 'Add ' + it.t + ' to cart');
    btn.textContent = 'Add';
    li.appendChild(btn);
    return li;
  }

  function inWindow(list, lo, hi, taken) {
    return list.filter(function (x) { return x.item.c >= lo && x.item.c <= hi && !taken[x.item.id]; });
  }

  function fillCart(box) {
    if (box.dataset.rbDone) return;
    box.dataset.rbDone = '1';
    var gap = parseInt(box.dataset.gap, 10) || 0;
    if (gap <= 0) return;
    var anchors = [];
    try { anchors = JSON.parse(box.dataset.anchors || '[]'); } catch (e) {}
    if (!anchors.length) return;
    var exclude = {};
    anchors.forEach(function (a) { exclude[a.id] = 1; a.tags = split(a.tags); a.tropes = split(a.tropes); });
    var books = anchors.filter(function (a) { return a.type === 'Book' && pre(a.tags, 'genre').length; });
    var merch = anchors.filter(function (a) { return a.type !== 'Book' && a.tags.length; });

    var jobs = [];
    books.slice(0, 2).forEach(function (a) {
      if (gap > BIG_GAP) jobs.push(similarBooks(a, exclude));
      jobs.push(matchingMerch(a, exclude));
    });
    merch.slice(0, 2).forEach(function (a) { jobs.push(booksForMerch(a, exclude)); });
    if (!jobs.length) return;

    Promise.all(jobs).then(function (lists) {
      // merge, keep best score per item
      var best = {};
      lists.forEach(function (list) { list.forEach(function (x) { var p = best[x.item.id]; if (!p || x.s > p.s) best[x.item.id] = x; }); });
      var all = Object.keys(best).map(function (k) { return best[k]; });
      var bookList = all.filter(function (x) { return x.item.y === 'Book'; }).sort(function (a, b) { return b.s - a.s; });
      var merchList = all.filter(function (x) { return x.item.y !== 'Book'; }).sort(function (a, b) { return b.s - a.s; });
      var first = gap > BIG_GAP ? bookList : merchList;
      var second = gap > BIG_GAP ? merchList : bookList;

      var picks = [], taken = {};
      function take(list) { list.forEach(function (x) { if (picks.length < MAX_PICKS && !taken[x.item.id]) { taken[x.item.id] = 1; picks.push(x); } }); }
      take(inWindow(first, gap, gap + 1000, taken));
      take(inWindow(second, gap, gap + 1000, taken));
      take(inWindow(first, gap, gap + 2500, taken));
      take(inWindow(second, gap, gap + 2500, taken));
      if (!picks.length) return;

      var ul = box.querySelector('.rb-fsb-sugg__list');
      var existing = Array.prototype.slice.call(ul.children);
      ul.innerHTML = '';
      picks.forEach(function (x) { ul.appendChild(cartCard(x)); });
      existing.forEach(function (li) { if (ul.children.length < MAX_PICKS && !taken[li.dataset.rbId]) ul.appendChild(li); });
      var title = box.querySelector('.rb-fsb-sugg__title');
      if (title) title.textContent = 'Add one for free shipping';
      box.hidden = false;
    }).catch(function () {});
  }

  /* ---------- book page: "You may also like" ---------- */
  function pageCard(x) {
    var it = x.item;
    var a = document.createElement('a');
    a.className = 'rb-pair__card';
    a.href = it.u;
    var img;
    if (it.i) { img = document.createElement('img'); img.src = it.i; img.alt = it.t; img.loading = 'lazy'; img.width = 300; img.height = 450; }
    else { img = document.createElement('span'); }
    img.className = 'rb-pair__img';
    a.appendChild(img);
    var name = document.createElement('span');
    name.className = 'rb-pair__name';
    name.textContent = it.t.split(' by ')[0];
    a.appendChild(name);
    var price = document.createElement('span');
    price.className = 'rb-pair__price';
    price.textContent = it.p;
    a.appendChild(price);
    if (x.why) { var w = document.createElement('span'); w.className = 'rb-pair__why'; w.textContent = x.why; a.appendChild(w); }
    return a;
  }

  function fillPage(box) {
    if (box.dataset.rbDone) return;
    box.dataset.rbDone = '1';
    var anchor = { id: parseInt(box.dataset.id, 10), title: box.dataset.title || '', type: 'Book', tags: split(box.dataset.tags), tropes: split(box.dataset.tropes) };
    var limit = parseInt(box.dataset.limit, 10) || 8;
    similarBooks(anchor, {}).then(function (list) {
      list = list.slice(0, limit);
      if (!list.length) return;
      var row = box.querySelector('.rb-pair__row');
      list.forEach(function (x) { row.appendChild(pageCard(x)); });
      box.hidden = false;
      document.body.classList.add('rb-also-ready');
    }).catch(function () {});
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rb-add]');
    if (!btn) return;
    e.preventDefault();
    var label0 = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = !!(drawer && btn.closest('cart-drawer'));
    var body = { items: [{ id: Number(btn.dataset.rbAdd), quantity: 1 }] };
    if (inDrawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (r) {
        if (!r.ok) { btn.textContent = 'Unavailable'; return; }
        if (inDrawer && r.json.sections) drawer.renderContents(r.json); else window.location.reload();
      })
      .catch(function () { btn.disabled = false; btn.textContent = label0; });
  });

  /* ---------- boot: run now and whenever the cart re-renders ---------- */
  function scan() {
    document.querySelectorAll('.rb-fsb-sugg[data-rb-cart]').forEach(fillCart);
    document.querySelectorAll('.rb-also[data-id]').forEach(fillPage);
  }
  var t;
  new MutationObserver(function () { clearTimeout(t); t = setTimeout(scan, 30); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);

  window.RBRecs = { similarBooks: similarBooks, matchingMerch: matchingMerch, booksForMerch: booksForMerch };
})();
